import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {CognitoAccessToken, GetUserTokenAccess, UserLoginRequest} from "./model";
import {environment} from "../../../../environments/environment";
import {JwtHelperService} from "@auth0/angular-jwt";


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private jwtHelper = new JwtHelperService();
  constructor(
    public http: HttpClient,
  ) { }

  loginUser(username: string, password: string): Observable<CognitoAccessToken> {
    const body =new HttpParams()
    .set('username', username)
    .set('password', password);

    let headers= new HttpHeaders({"content-type": "application/x-www-form-urlencoded"})

    return this.http.post<CognitoAccessToken>(environment.apiUrl + "/oauth/token", body, { headers: headers });
  }

  setToken(username:string, token: string): void {
    localStorage.setItem('username', username);
    localStorage.setItem('access_token', token);
    //localStorage.setItem('is_admin', String(is_admin))
  }

  getToken(): string | null {
    return localStorage.getItem('access_token');
  }

  isLoggedIn(): boolean {
    const token = this.getToken();
    return!this.jwtHelper.isTokenExpired(token);
  }

  isAdmin(): boolean {
    return localStorage.getItem('is_admin') === 'true'
  }

  // Method to log out
  logout(): void {
    localStorage.removeItem('access_token');
  }

}
